document.addEventListener('DOMContentLoaded', () => {
  window.PAGE_LOAD_END = performance.now();
});
